import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { CircularLoader } from '../../../shared';
import styled from 'styled-components';
import { FC } from 'react';

const StyledIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #666;
  gap: 4px;
`;

interface Props {
  testId?: string;
  show?: boolean;
}

export const NgBuildIcon: FC<Props> = ({ testId = 'SettingsOutlinedIcon', show = false }) => {
  if (!show) {
    return null;
  }

  return (
    <StyledIcon style={{}}>
      <CircularLoader icon={<SettingsOutlinedIcon />} size={20} testId={testId} spinIcon />
    </StyledIcon>
  );
};
